import ShipperSaveDetail from "@/classes/models/ShipperSaveDetail";

export default class ConsigneeSaveDetail extends ShipperSaveDetail {
    constructor() {
        super();

    }

}
